import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { useGetCaseForGrade } from '@/hooks/api/use-get-case-for-grade';

import { GradeForm } from './legacy-grade-form/legacy-grade-form';
import { GradeFlow } from './grade-flow';
import { FetchStates } from '../fetch-states';

export function GradeCase() {
  const { caseId } = useParams<{ caseId: string }>();
  const { data: _case, loading, error } = useGetCaseForGrade({ caseId });

  const currentGradeCase = useMemo(() => {
    if (!_case?.grades) return undefined;

    return _case.grades.sort((a, b) => {
      // from createdUtc = "2024-07-17 18:50:57.981410+00:00"
      return new Date(b.createdUtc).getTime() - new Date(a.createdUtc).getTime();
    })[0];
  }, [_case]);

  if (!_case) {
    return <FetchStates loading={loading} error={error?.message} />;
  }

  if (!currentGradeCase || parseInt(currentGradeCase._v as string) === 2) {
    return <GradeFlow selectedCase={_case} />;
  }

  return <GradeForm />;
}
